import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon } from 'lucide-react';
const nodes = [{
  icon: FileTextIcon,
  label: 'Prompt',
  sub: 'your instruction + context',
  tone: 'bg-white text-plum border-grape-soft/50',
  iconTone: 'bg-lilac-soft text-grape'
}, {
  icon: CpuIcon,
  label: 'AI',
  sub: 'ChatGPT · Claude · Gemini · DeepSeek',
  tone: 'bg-plum text-white border-plum',
  iconTone: 'bg-grape-soft text-plum'
}, {
  icon: FileCheck2Icon,
  label: 'Result',
  sub: 'a structured draft you review',
  tone: 'bg-white text-plum border-grape-soft/50',
  iconTone: 'bg-lilac-soft text-grape'
}];
export function PromptFlow() {
  return <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center" aria-label="How a prompt works" data-id="element-254" data-mp="2zkqspyphefua">
      {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-255" data-mp="156zo5dm0em5p" data-mpi={i}>
          <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3 sm:w-60 ${n.tone}`} data-id="element-256" data-mp="15810dlerhep0">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.iconTone}`} data-id="element-257" data-mp="1a758s9tv38ea">
              <n.icon className="h-5 w-5" data-id="element-258" data-mp="1f1jle2htucvn" />
            </span>
            <div className="min-w-0" data-id="element-259" data-mp="1a7fgrpw1agxq">
              <p className="font-display text-base font-black" data-id="element-260" data-mp="159x53rqmtnm1">{n.label}</p>
              <p className="truncate text-xs opacity-70" data-id="element-261" data-mp="15a6zdripmgxj">{n.sub}</p>
            </div>
          </div>
          {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 rotate-90 text-grape sm:mx-0 sm:rotate-0" aria-hidden="true" data-id="element-262" data-mp="1xyckwghl89yf" />}
        </React.Fragment>)}
    </div>;
}